import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function useOutlayCompanyData(companyId?: number) {
    const { data: outlayCompanies, isPending: isPendingOutlayCompanies } = useQuery({
        queryKey: ['outlay-companies-options', companyId],
        queryFn: async () => {
            const { data } = await axios.get('/outlay/companies');

            return data?.data ?? [];
        },
        placeholderData: [],
        retry: 1,
        enabled: !!companyId,
    });

    return {
        outlayCompanies,
        isPendingOutlayCompanies,
    };
}
